import { gql, TypedDocumentNode } from "@apollo/client";

import { ManagedUser, Maybe, OidcSettings, SamlSettings, ScimOauthClient } from "types/generated";

type FetchSSOSettingsQuery = {
  hasSSO: boolean;
  managedUsers: Array<Pick<ManagedUser, "id">>;
  samlSettings: Maybe<SamlSettings>;
  oidcSettings: Maybe<OidcSettings>;
  scimSettings: Maybe<Pick<ScimOauthClient, "clientID" | "accessTokenEndpoint" | "connnectorBaseURL">>;
};
export const GET_SSO_SETTINGS: TypedDocumentNode<FetchSSOSettingsQuery> = gql`
  query GetSSOSettings {
    hasSSO
    managedUsers {
      id
    }
    samlSettings {
      adminLogin
      idpMetadata
      idpMetadataURL
      nameIDFormat
      claimMapping {
        entries {
          name
          value
        }
      }
    }
    oidcSettings {
      adminLogin
      clientId
      identityProviderHost
      claimMapping {
        entries {
          name
          value
        }
      }
    }
    scimSettings {
      clientID
      accessTokenEndpoint
      connnectorBaseURL
    }
  }
`;
